import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomersBaseComponent } from './features/customers/containers/customers-base/customers-base.component';
import { EmptyRouteComponent } from './core/components/empty-route/empty-route.component';
import { ForgotPasswordComponent } from './features/auth/forgotpassword/forgotpassword.component';
import { LoginComponent } from './features/auth/login/login.component';
import { OrdersBaseComponent } from './features/orders/containers/orders-base/orders-base.component';
import { ResetPasswordComponent } from './features/auth/resetpassword/resetpassword.component';
import { ResourcesComponent } from './features/resources/resources.component';
import { AuthGuard } from './core/guards/auth.guard';
import { SignUpComponent } from './features/auth/signup/signup.component';
import { ManageusersInternalComponent } from './features/manageusers/containers/manageusers-internal/manageusers-internal.component';
import { AdminGuard } from './core/guards/admin.guard';
import { ManageusersExternalComponent } from './features/manageusers/containers/manageusers-external/manageusers-external.component';
import { UnsavedChangesCanDeactivateGuard } from './core/guards/candeactivate.guard';
import { OrdersStartComponent } from './features/orders/containers/orders-start/orders-start.component';
import { ManageusersProfileComponent } from './features/manageusers/containers/manageusers-profile/manageusers-profile.component';
import { OrdersDetailsComponent } from './features/orders/containers/orders-details/orders-details.component';
import { CustomersDetailsComponent } from './features/customers/containers/customers-details/customers-details.component';
import { CustomersShipToComponent } from './features/customers/containers/customers-ship-to/customers-ship-to.component';
import { CustomersVehiclesMaintenanceComponent } from './features/customers/containers/customers-vehicles-maintenance/customers-vehicles-maintenance.component';
import { CustomerOrdersComponent } from './features/customers/containers/customer-orders/customer-orders.component';
import { CustomersVehiclesDetailsComponent } from './features/customers/containers/customers-vehicles-details/customers-vehicles-details.component';
import { CustomersVehiclesDetailsNewComponent } from './features/customers/containers/customers-vehicles-details-new/customers-vehicles-details-new.component';
import { CustomersDetailsNewComponent } from './features/customers/containers/customers-details-new/customers-details-new.component';
import { CustomersInvoiceComponent } from './features/customers/containers/customers-invoice/customers-invoice.component';
import { CustomersStatementComponent } from './features/customers/containers/customers-statement/customers-statement.component';
import { RegisterAdminComponent } from './features/register-admin/register-admin.component';
import { RegisterGuard } from './core/guards/register.guard';
import { WarrantyformComponent } from './features/warrantyform/containers/warrantyform.component';
import { ManageusersShowComponent } from './features/manageusers/containers/manageusers-show/manageusers-show.component';
import { CustomersShowSalesComponent } from './features/customers/containers/customers-show-sales/customers-show-sales.component';
import { CustomersNotesComponent } from './features/customers/containers/customers-notes/customers-notes.component';
import { CustomersTaskCalendarComponent } from './features/customers/containers/customers-task-calendar/customers-task-calendar.component';
import { ContentComponent } from './features/content/content.component';
import { CustomersMyOrdersComponent } from './features/customers/containers/customers-my-orders/customers-my-orders.component';
import { AllocateFitterComponent } from './features/filter/containers/allocate-fitter/allocate-fitter.component';
import { CamperTrailerComponent } from './features/camper-trailer/containers/camper-trailer/camper-trailer.component';
import { LandingComponent } from './features/epc/containers/landing/landing.component';
import { LandingMainComponent } from './features/epc/components/landing-main/landing-main.component';
import { ProductListComponent } from './features/epc/containers/product-list/product-list.component';
import { ProductComponent } from './features/epc/containers/product/product.component';
import { EpcGuard } from './core/guards/epc.guard';
import { ShowAdminGuard } from './core/guards/show-admin.guard';
import { SchedulerComponent } from './features/scheduler/scheduler.component';
import { SchedulerWeekComponent } from './features/scheduler/schedulerWeek/schedulerWeek.component';
import { ManagePartnerComponent } from './features/partner/manage-partner.component';
import { PartnerProgramComponent } from './features/partner/manage-partner-program/partnerprogram.component';
import { CustomersQuotesOrdersComponent } from './features/customers/components/customer-order/customers-quotes-orders/customers-quotes-orders.component';
import { CustomersArbOrdersComponent } from './features/customers/components/customer-order/customers-arb-orders/customers-arb-orders.component';
import { CustomersClosedArbOrdersComponent } from './features/customers/components/customer-order/customers-closed-arb-orders/customers-closed-arb-orders.component';
import { CustomersClickAndCollectComponent } from './features/customers/components/customer-order/customers-click-collect-orders/customers-click-collect-orders.component';
import { CustomerPosArbOrdersComponent } from './features/customers/components/customer-order/customers-pos-arb-orders/customers-pos-arb-orders.component';
import { CentralComponent } from './features/central/central.component';
import { StockavailabilityComponent } from './features/customers/containers/customers-stockavailability/stockavailability.component';
import { CustomersTrailerSearchComponent } from './features/customers/components/customers-trailer-search/customers-trailer-search.component';
import { CustomerGiftCardBalanceSearchComponent } from './features/customers/containers/customer-gift-card/gift-card-balance-search.component';
import { TaskComponent } from './features/central/components/task/containers/task.component';
import { IframeBaseComponent } from './features/iframeContainer/iframeBaseComponent/iframe-base.component';
import { NewTaskComponent } from './features/central/components/task/components/task-new/task-new.component';
import { OpenTaskComponent } from './features/central/components/task/components/task-open/task-open.component';
import { TaskDetailComponent } from './features/central/components/task/components/task-detail/task-detail.component';
import { ClosedTaskComponent } from './features/central/components/task/components/task-close/task-closed.component';
import { ArbCentralSecurityGuard } from './core/guards/arbCentralSecurityGuard';
import { ManageHelpComponent } from './features/central/components/manage-help-component/manage-help-component.component';
const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'pos/login',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'signup',
    component: SignUpComponent,
  },

  {
    path: 'pos/orders',
    children: [
      {
        path: '',
        component: OrdersBaseComponent,
      },
      {
        path: 'customer/:customerNumber',
        component: OrdersBaseComponent,
      },
      {
        path: ':id',
        component: OrdersDetailsComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'pos/orders-start',
    component: OrdersStartComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pos/resources',
    component: ResourcesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pos/resources/:id',
    component: ResourcesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pos/customers/search',
    component: CustomersBaseComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'pos/my-orders',
    children: [
      {
        path: 'current',
        component: CustomersMyOrdersComponent,
      },
      {
        path: 'quotes',
        component: CustomersQuotesOrdersComponent,
      },
      {
        path: 'arb-orders',
        component: CustomersArbOrdersComponent,
      },
      {
        path: 'closed-arb-orders',
        component: CustomersClosedArbOrdersComponent,
      },
      {
        path: 'click-and-collect',
        component: CustomersClickAndCollectComponent,
      },
      {
        path: 'pos-arb-orders',
        component: CustomerPosArbOrdersComponent,
      },
    ],

    canActivate: [AuthGuard],
  },
  {
    path: 'pos/customers/new',
    component: CustomersBaseComponent,
    children: [
      {
        path: '',
        component: CustomersDetailsNewComponent,
        canDeactivate: [UnsavedChangesCanDeactivateGuard],
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'pos/customers/:id',
    component: CustomersBaseComponent,
    children: [
      { path: '', redirectTo: 'details', pathMatch: 'full' },
      {
        path: 'details',
        component: CustomersDetailsComponent,
        canDeactivate: [UnsavedChangesCanDeactivateGuard],
      },
      {
        path: 'invoice',
        component: CustomersInvoiceComponent,
      },
      {
        path: 'statement',
        component: CustomersStatementComponent,
      },
      {
        path: 'showsales',
        component: CustomersShowSalesComponent,
      },
      {
        path: 'shipTo',
        component: CustomersShipToComponent,
        canDeactivate: [UnsavedChangesCanDeactivateGuard],
      },
      {
        path: 'vehicles',
        component: CustomersVehiclesMaintenanceComponent,
      },
      {
        path: 'orders',
        component: CustomerOrdersComponent,
      },
      {
        path: 'vehicles/:id',
        component: CustomersVehiclesDetailsComponent,
        canDeactivate: [UnsavedChangesCanDeactivateGuard],
      },
      {
        path: 'add/vehicles',
        component: CustomersVehiclesDetailsNewComponent,
        canDeactivate: [UnsavedChangesCanDeactivateGuard],
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'pos/customers/:id/notes',
    component: CustomersNotesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pos/customers/:id/taskCalendar',
    component: CustomersTaskCalendarComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pos/manageusers/internal',
    component: ManageusersInternalComponent,
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'pos/manageusers/external',
    component: ManageusersExternalComponent,
    canActivate: [AuthGuard, AdminGuard],
    canDeactivate: [UnsavedChangesCanDeactivateGuard],
  },
  {
    path: 'pos/manageusers/show',
    component: ManageusersShowComponent,
    canActivate: [AuthGuard, ShowAdminGuard],
  },
  {
    path: 'pos/manageusers/profile',
    component: ManageusersProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pos/register',
    component: RegisterAdminComponent,
    canActivate: [AuthGuard, RegisterGuard],
  },
  {
    path: 'pos/allocate-fitter',
    component: AllocateFitterComponent,
  },
  {
    path: 'pos/warranty',
    component: WarrantyformComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'pos/content',
    component: ContentComponent,
  },
  {
    path: 'pos/camper-trailer/:id',
    component: CamperTrailerComponent,
  },
  {
    path: 'pos/scheduler/:day/:month/:year/timeline',
    component: SchedulerComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'pos/scheduler/:day/:month/:year/week',
    children: [
      { path: '', component: SchedulerWeekComponent },
      { path: ':part', component: SchedulerWeekComponent },
    ],
  },
  {
    path: 'stock/search',
    component: StockavailabilityComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'epc',
    canActivate: [AuthGuard, EpcGuard],
    children: [
      {
        path: '',
        component: LandingComponent,
        children: [
          { path: '', component: LandingMainComponent, pathMatch: 'full' },
          {
            path: 'category/:id',
            data: {
              breadcrumb: 'Category',
            },
            component: ProductListComponent,
          },
          {
            path: 'product/:productNumber',
            data: {
              breadcrumb: 'Product',
            },
            component: ProductComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'pos/partner/manage',
    component: ManagePartnerComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'pos/partner/program',
    component: PartnerProgramComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'central',
    component: CentralComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'central/task/new',
    component: NewTaskComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },

  {
    path: 'central/task/open',
    component: OpenTaskComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'central/tasks/closed',
    component: ClosedTaskComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'central/task/detail/:id/latest',
    component: TaskDetailComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'central/task/detail/:id',
    component: TaskDetailComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'central/tasks',
    component: TaskComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'central/task-search-order/:orderNumber/:orderType',
    component: TaskComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'central/task-search-customer/:customerNumber/:customerName',
    component: TaskComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: 'central/help-how-to/:id',
    component: IframeBaseComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'central/gift-card-balance/search',
    component: CustomerGiftCardBalanceSearchComponent,
  },
  {
    path: 'central/camper-trailer/search',
    component: CustomersTrailerSearchComponent,
  },
  {
    path: 'central/manage/how-to-help-component',
    component: ManageHelpComponent,
    canActivate: [AuthGuard, ArbCentralSecurityGuard],
  },
  {
    path: '**',
    component: EmptyRouteComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
})
export class AppRoutingModule {}
